/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SportBallTennisIcon20Solid = forwardRef('SportBallTennisIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.07 8.932A8.005 8.005 0 0 1 8.933 2.07a7.223 7.223 0 0 1-2.114 4.748 7.223 7.223 0 0 1-4.747 2.114Z" }),
        React.createElement("path", { d: "M7.879 7.879a8.719 8.719 0 0 0 2.557-5.868 8 8 0 0 1 7.552 7.553 8.72 8.72 0 0 0-5.867 2.557 8.72 8.72 0 0 0-2.557 5.867 8 8 0 0 1-7.552-7.552 8.719 8.719 0 0 0 5.867-2.557Z" }),
        React.createElement("path", { d: "M17.93 11.068a8.005 8.005 0 0 1-6.862 6.86 7.223 7.223 0 0 1 2.114-4.746 7.223 7.223 0 0 1 4.747-2.114Z" })));
});
